// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-sop {

    background-color: #ffffff;
    width:100%;
    font-family: 'Graphik', sans-serif;
    display:flex;
    flex-direction:column;
   
  
  }
  .header-sop {
    background-color: #fff;
    justify-items: center;
    align-items: center;
    display: flex;
    border: 1px solid #747BA9;
    flex-direction: row;
    height: 70px;
  }
  .logo-header-sop{
  
    width:25%;
  }
  .Heading-sop{
    color: black;
    text-align: left;
    font-size: 20px;
  }
  .admin-img-sop{
    width: 85%;
  }
  .admin-text-sop{
    margin-left: 10px;
    margin-right: 10px;
    font-size: 14px;
    color: black;
  }
  
  .collapse-img-sop{
    justify-content: end;
    padding-right: 10px;
    align-items: center;
    align-self: flex-end;
   }
  
  
  .Admin-sop{
   display: flex;
   flex-direction: row;
   margin-left: 1100px;
   justify-content: end;
   padding-right: 10px;
   align-items: center;
   align-self: flex-end;
  }
  
  
  .second-container-sop {
    
  
  
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    border-radius: 10px;
    border: 1px solid #747BA9;
    margin-left: 30px;
    min-height: 540px;
   
    padding: 20px;
    margin-right: 15px;
    text-align: left;
    background-color: white;
  
  }
  .text-sop{
    color:#000;
    font-size: 12px;
  }
  top-containerss-sop{
    display: flex;
   
    flex-direction: column;
  }
  .top-container-sop{
    display: flex;
    background-color: #202342;
    flex-direction: row;
    
    min-height: 40px;
    border: 1px solid #747BA9;
  }
  .left-section-sop{
    display: flex;
    width: 55%;
    flex-direction: column;
    background-color:   rgba(255, 255, 255, 0.05);
  }
  .select-dropdown-s{
    color: #000;
    display: flex;
    flex-direction: row;
    font-size: 10px;
    padding-top: 20px;
  }
  .id::placeholder{
    color: white;
    font-size: 13px;
    font-weight: 500;
    justify-content: center;
  }
  .data-display-sop{
    color: black;
  
  }
  
  .button-sop{
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    width: 50%;
    background-color: #6B5CD1;
    border-radius: 5px;
    border: 1px solid #747BA9;
   
   
    
    margin: 5px;
    justify-content: center;
   
    height:30px;
  }
  /* Add styles for the custom Accordion */
  .custom-accordion-sop {
    background-color: #294170;
    border: none; /* Remove default border */
  }
  
  /* Style for each Accordion item */
  
  
  /* Style for Accordion headers */
  .custom-accordion-header-sop {
   
    color: white; /* Set text color for headers */
    background-color: #fff;
    font-size: 12px;
    padding: 0px;
    cursor: pointer;
  }
  
  /* Style for Accordion bodies */
  .custom-accordion-body-sop {
   color: white;
   font-size: 12px;
    padding: 10px; /* Adjust padding as needed */
  }
  
  .loading-sop {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #000;
    margin-top: 10px;
  }
  .multiSelectContainer-sop {
    position: relative;
    border-radius: 3px;
    background-color: #FFFFFF;
    text-align: left;
    color:#A100FF;
    font-size: 12px;
    width: 100%;
  }
  
  .loading-sop::after{
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid #747BA9;
    border-top-color: transparent;
    animation: spin 0.8s linear infinite;
  }
  
  @keyframes spin {
    to-s {
      transform: rotate(360deg);
    }
  }
  .assistant-heading-sop {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
    margin-left: 5px;
    color: white;
    text-align: center;
    
  }
  
  
  
  
  .middle-panel-sop {
  
    display: flex;
  
    width:45%;
  
    padding:20px;
    padding-top:5px;
    flex-direction: column;
  
    justify-content: start;
  
    align-items: center;
  
    background-color: #fff;
  
  }
  
  
  
  
  .right-panel-sop {
  
    position: relative;
    width:30%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background: linear-gradient(0deg, #002644, #002644),
    linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2));
    border: 1px solid #747BA9;
  
  }
  
  
  
  
  .title-sop {
  
    font-family: 'Arial', sans-serif;
  
    font-size: 28px;
  
    color: #333;
  
    margin-bottom: 20px;
  
  }
  
  
  
  
  .dropdown-container-sop {
  
    margin-bottom: 20px;
  
  }
  
  
  .dropdown-label-sop {
  
    color:black;
    font-size:12px;
    margin-top: 10px;
    margin-right: 50px;
  }
  .custom-multiselect .multiselect__placeholder::before {
    content: 'Select Category'; /* Set the placeholder text */
    color: #ffffff; /* Set the text color to white */
    /* Add any other custom styles for the placeholder */
  }
  
  .logo-class-sop{
    
    width: 70%;
    margin-left: 20px;
  }
  .selected-files-container-sop {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    min-height: 50px;
  }
  .pdf-icon-sop{
    padding: 10px;
  
  }
  .browse-sop{
    align-content: center;
    color: #fff;
    font-size: 13px;
    margin-left:80px;
   margin-top:14px;
   padding:5px;
   border:1px solid  #747BA9;
   margin-right:5px;
   height:30px;
   border-radius:3px;
    font-weight:500;
  }
  .top-suma1-sop{
    width: 2.5%;
   
    margin-right: 5px;
   
  
  }
  .chatboticon {
    float: right;
}
  .top-suma-sop{
    width: 2.5%;
    
   
   
  }
  /* CSS for selected files */
  .selected-file-sop {
    background-color: rgba(255, 255, 255, 0.05);
    display: flex;
    flex-direction: row;
    width: 60%;
    min-height: 40px;
    margin-left: 30px;
    margin-top: 20px;
    text-align: center;
    border-radius: 4px;
    color: #fff;
    font-size: 10px;
  }
 
  .dropdown-select-s {
  
    background: #FFFFFF;
    appearance: none;
    border: 2px dashed;
    height: 30px;
    border-radius: 3px;
    border: 1px;
    color:#A100FF;
    font-size: 12px;
  
  }
  
  .option-class-s{
    background-color:#FFFFFF;
  }
  .option-class-s:checked{
    background-color: #fff;
  }
  .category-container-s{
    width: 50%;
    background: #FFFFFF;
    border: 2px dashed;
    box-shadow: 0px 0px 0px 2px grey;
    height: 30px;
    border-radius: 3px;
    border: 1px;
    color:#8392B6;
    font-size: 12px;
  
  }
  
  .drag-sop{
    align-content: center;
    color:#FFFFFF;
    font-size: 12px;
    font-weight:500;
  }
  
  /* .drag-logo{
  
    
  
  } */
  

  .accordion-button {
    width: 100%;
    background-color: white;
    max-height: 40px;
    color: black;
  }
  .accordion-button:not(.collapsed){
    background-color:#3C4069 ;
    color: #fff;
  }
  .accordion-button.collapsed{
    background-color:#747BA9 ;
    color: #fff;
  }
 
  .header-class-sop{
    background-color: white;
  }
  
  .file-class-sop{
    visibility:hidden;
  }
  
  .or-class-sop{
    color:#FFFFFF4D;
    font-size: 12px;
    font-weight:500;
  }
  .Assist-header-sop{
   
    align-self: flex-start;
    margin-left: 35px;
    color:#A100FF;
  }
  
  .upload-container-sop {
  
    margin-bottom: 10px;
    margin-top: 30px;
    text-align: center;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content:center;
    height: 130px;
    border-radius: 15px;
    background: #294170;
    border: 1px solid #747BA9;
  
  }
  .drag-container-sop{
   
    background-color: #3E5FA2;
    border-radius: 5px;
    height: 30px;
    align-items: center;
    display: flex;
    align-self: center;
    width: 40%;
    flex-direction: row;
  }
  .drag-logo-sop{
    width: 90%;
  }
  .collapse-class{
    width:3%;
  }
  
  .placeholder{
    background-color: #fff;
    color:#FFFFFF;
    font-size: 10px;
  }
  .browse-container-sop{
    background-color: #6B5CD1;
    border-radius: 5px;
    border: 1px solid #747BA9;
    margin: 5px;
    padding-left: 50px;
    height: 30px;
    display: flex;
   
    align-items: center;
    width: 40%;
    font-size: 10px;
    flex-direction: row;
  }
  
  .image-sop{
    display: flex;
    margin-top: 25px;
    margin-left: 20px;
    flex-direction: row;
  }
  .energy-header-sop{
    font-size: 35px;
    text-align: center;
    font-weight: 8px;
    color: #ffffff;
  }
  
  .upload-container-sop label{
  
    display: block;
  
  }
  
  
  
  .corrosion-result-sop{
    margin-bottom: 10px;
    text-align: center;
    padding: 10px;
    justify-content:center;
    font-size:15px;
    font-weight:500;
    color:#FFFFFF;
    min-height: 20px;
    border-radius: 24px;
    background: linear-gradient(0deg, #122B45, #122B45);
    border: 1px solid #747BA9;
  
  }
  
  
  .upload-container-sop input[type='file'] {
  
    display: block;
    
  
  }
  
  .multipleSelection-sop {
    padding-left: 30px;
    width: 80%;
    
  }
  
  .selectBox-sop {
    position: relative;
  }
  
  .selectBox-sop select {
    width: 100%;
    background: #FFFFFF;
    border: 2px dashed;
    box-shadow: 0px 0px 0px 2px grey;
    height: 30px;
    padding: 5px;
    border-radius: 3px;
    border: 1px;
    color:#8392B6;
    font-size: 12px;
    
  }
  
  .overSelect-s {
    position: absolute;
    
  }
  
  .micimg-sop{
    
   
    width: 70%;
  
  }
  
  #checkBoxes-s {
    /* display: none; */
    border: 1px #8DF5E4 solid;
  }
  
  #checkBoxes label-s {
    display: block;
  }
  
  #checkBoxes label:hover-s {
    background-color: #4F615E;
  }
  
  
  .corrosion-detection-s {
  
  
    font-size: 24px;
  
    color: #FFFFFF;
  
    margin-bottom: 10px;
  
  }
  
  

 
  
  
  .chat-popup-sop {
  
    
  
    display: flex;
    flex-direction: column;
    text-align: right;
  
    align-items: flex-end;
  
    /* background-color: #007bff; */
  
    color: white;
  
    padding: 10px;
  
    border-radius: 5px;
  
    cursor: pointer;
  
  }
  
  
  
  
  .robot-icon-sop {
  
    width: 20px;
  
    height: 20px;
  
    margin-right: 10px;
  
    background-image: url('https://www.ibef.org/assets/images/Oil-Gas-2.jpg'); /* Replace with the path to your custom robot icon image */
  
    background-size: cover;
  
  }
  
  .chat-popup-text-sop {
  
    font-size: 14px;
  
  }
  .summary-sop{
    font-size: 17px;
    
    margin: 30px;
    color: #000;
  }
  .summary-header-sop{
    font-size: 20px;
    margin-top: 30px;
    margin-left: 40px;
    font-weight: 20px;
    color:#fff;
  }
  .icon-sop{
    margin-right: 50px;
  }
  .icon-row-sop{
    display: flex;
    flex-direction: row;
    padding-top: 10px;
    padding-bottom: 10px;
    border-top: 1px solid #747BA9;
    border-bottom: 1px solid #747BA9;
    margin-top: 40px;
    padding-left: 40px;
  }
  /* Add your other CSS styles here */
  
  .header-starts-with-hyphen {
    /* Apply your custom styling for headers starting with hyphen */
    /* For example: */
    background-color: lightgray;
  }
  .internalItemClasses{
    color:red;
  }
  .header-is-numeric {
    /* Apply your custom styling for numeric headers */
    /* For example: */
    background-color: lightblue;
  }
  
  /* ... (Other CSS rules) */
  
  
  .chatbot-container-sop {
  
    flex: 1 1;
    /* padding: 10px; */
    display: flex;
    flex-direction: column;
    background-color: #1E203D;
    width: 100%;
    align-self: center;
   
    border: 1px solid #747BA9;
  
    border-radius: 3px;
  
  }
  .top-chat-container-sop{
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    border-radius: 5px;
    border-color: #8392B6;
    height: 60px;
    border: 3px; 
    text-align: left;
    background-color: #4B70B4;
  
  }
  .right-section-sop{
      display: flex;
      flex-direction: column;
      background-color: #fff;
      width:720px;
      background-color: #252843;
      border: 1px solid #747BA9;
      border-radius: 3px;
      align-content: flex-end;
  }
  .popup-message-sop{
    background-color: #8392B6;
    color: #ffffff;
  }
  .message-footer-apm {
    display: flex;
    /* background-color: rgba(116, 123, 169, 1); */
    border: 1px solid rgba(116, 123, 169, 1);
    height: 34px;
    justify-content: space-between;
    padding: 5px 10px 5px 10px;
    margin-left: -10px;
    margin-right: -10px;
    margin-bottom: -10px;
    margin-top: 20px;
    border-radius: 0px 0px 10px 10px;
}
  .message-text-chart-apm{
    padding: 10px 10px 10px 10px;
    font-size: 12px;
    color: white;
    border-radius: 5px;
    max-width: 1000px;
    width: fit-content;
    margin-left: 30px;
  }
  
  .chat-messages-sop {
    overflow-y:  scroll;
    height: 430px;
   
    margin-bottom: 10px;
  
  }
  
  .chat-icon-sop{
    width:20%;
  }
  
  
  .chat-message-sop {
  
    padding: 10px;
  
    margin-bottom: 5px;
    
    border-radius: 5px;
  
    font-family: 'Arial', sans-serif;
  
    font-size: 14px;
  
  }
  .searchWrapper {
    padding: 2px;
  
  }
  
  
  
  .user-sop {
  
    
    display: flex;
    flex-direction: row;
    text-align:start;
    margin: 10px;
    padding: 10px;
    background-color: #F5FBFF;
    border: 1px solid #747BA9;
    border-radius: 5px;
    min-height: 35px;
    color:black;
  
  }
  .dropdowns{
    display: flex;
    flex-direction: row;
  }
  
  .accordion-header {
    cursor: pointer;
    font-size: 12px;
  }
  .Category-select-sop{
    background-color: #4286F5;
    border-radius: 5px;
    border: 1px solid #747BA9;
    margin: 10px;
    color: white;
   
    height: 30px;
    display: flex;
    min-height: 50px;
    align-items: center;
    width: 100%;
    font-size: 13px;
    font-weight: 500;
    flex-direction: row;
  }
  
  .message-icon-sop{
    padding-right: 10px;
    padding-bottom: 5px;
  }
  
  .bot-sop {
  
   
    display: flex;
    flex-direction: row;
    padding: 10px;
    border-radius: 5px;
    background-color: #CBDEFF;
    border: 1px solid #8799C5;
    color: black;
    min-height: 35px;
    margin: 10px;
  
  }
  
  .container-sop{
    height: 550px;
    display: flex;
    background-color: #202342;
    flex-direction: row;
  }
  
  
  .chat-input-container-sop {
  
    display: flex;
    flex-direction: row;
    align-items: center;
    color:#000;
    padding: 5px;
   
    
  }
  .Title-sop{
    color: #000;
    
    font-size: 30px;
    margin-left: 400px;
  }
  
  .send-sop{
    
    width: 5%;
    
    
  }

  .Assistant-sop{
    font-size: 18px;
    font-weight: 400;
    display: flex;
    flex-direction: row;
    background-color:#252843;
   
    padding-top: 5px;
    text-align: center;
    height: 35px;
    margin-bottom: 5px;
    color: #000;
  }
  .assis-sop{
    padding-left: 200px;
   color: white;
   font-weight: 500;
   font-family: 'Graphik', sans-serif;
    background-color:#252843;
  }
  .icon-o{
    margin-right: 50px;
    height: 30px;
    color: #6C3287;
   
  }
  .icon-row-o{
    display: flex;
    flex-direction: row;
    padding-top: 10px;
    padding-bottom: 10px;
    border-top: 1px solid #8392B6;
    border-bottom: 1px solid #8392B6;
    margin-top: 40px;
    padding-left: 40px;
  }
  .fetch-questions-button-sop{
    color:#fff;
     
      margin-bottom: 5px;
      margin-left: 130px;
     
     
     
      
    }
  .iconi-sop{
    width: 50%;
    margin-bottom: 5px;
  }
  
  .chat-input-sop {
  
    margin-left: 10px;
    margin-right: 10px;
  
    padding: 5px;
    width: 100%;
   
    color: #fff;
    font-size: 14px;
    height: 50px;
    border-radius:10px;
    background-color:#1A1C35;
    border: 1px solid #747BA9;
  
  }
  
  .chat-input-sop:focus{
    border: 1px solid #747BA9;
  }
  .check-image-s{
    border-radius: 10px;
  
  
  }
  
  .footer-s {
  
    font-family: 'Arial', sans-serif;
  
    font-size: 14px;
  
    color: #666;
  
    text-align: center;
  
    margin-top: auto;
  
  }
  
  
 
  
 
  /* Handle */
  
 
  
  .icon_down_dir:before {
      content: "";
  }
  
  .accordion-body{
    background-color: #1E203D;
    color: white;
    overflow-y: scroll;
    max-height: 360px;
  }
  .accordion-item {
    background-color: #1E203D;
  }
  .autocomplete-container .suggestions-container ul li a{
  
    font: normal normal normal 14px/25px Graphik !important;
  
    letter-spacing: 0px;
  
    color: #5C5C5C !important;
  
    padding: 0 5px !important;
  
  }
  /* .multiSelectContainer .icon_down_dir::before-s { content: url("./images/dropdown_arrow.svg"); } */`, "",{"version":3,"sources":["webpack://./src/SOP.css"],"names":[],"mappings":"AAAA;;IAEI,yBAAyB;IACzB,UAAU;IACV,kCAAkC;IAClC,YAAY;IACZ,qBAAqB;;;EAGvB;EACA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;EACd;EACA;;IAEE,SAAS;EACX;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;GACrB;;;EAGD;GACC,aAAa;GACb,mBAAmB;GACnB,mBAAmB;GACnB,oBAAoB;GACpB,mBAAmB;GACnB,mBAAmB;GACnB,oBAAoB;EACrB;;;EAGA;;;;IAIE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;;IAEjB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;;EAEzB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,aAAa;;IAEb,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;;IAEnB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,UAAU;IACV,sBAAsB;IACtB,6CAA6C;EAC/C;EACA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,YAAY;;EAEd;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;;;;IAIzB,WAAW;IACX,uBAAuB;;IAEvB,WAAW;EACb;EACA,wCAAwC;EACxC;IACE,yBAAyB;IACzB,YAAY,EAAE,0BAA0B;EAC1C;;EAEA,kCAAkC;;;EAGlC,gCAAgC;EAChC;;IAEE,YAAY,EAAE,+BAA+B;IAC7C,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;GACC,YAAY;GACZ,eAAe;IACd,aAAa,EAAE,6BAA6B;EAC9C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;;EAEpB;;;;;EAKA;;IAEE,aAAa;;IAEb,SAAS;;IAET,YAAY;IACZ,eAAe;IACf,sBAAsB;;IAEtB,sBAAsB;;IAEtB,mBAAmB;;IAEnB,sBAAsB;;EAExB;;;;;EAKA;;IAEE,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB;6EACyE;IACzE,yBAAyB;;EAE3B;;;;;EAKA;;IAEE,gCAAgC;;IAEhC,eAAe;;IAEf,WAAW;;IAEX,mBAAmB;;EAErB;;;;;EAKA;;IAEE,mBAAmB;;EAErB;;;EAGA;;IAEE,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,0BAA0B,EAAE,6BAA6B;IACzD,cAAc,EAAE,gCAAgC;IAChD,oDAAoD;EACtD;;EAEA;;IAEE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,aAAa;;EAEf;EACA;IACE,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,gBAAgB;GACjB,eAAe;GACf,WAAW;GACX,yBAAyB;GACzB,gBAAgB;GAChB,WAAW;GACX,iBAAiB;IAChB,eAAe;EACjB;EACA;IACE,WAAW;;IAEX,iBAAiB;;;EAGnB;EACA;IACE,YAAY;AAChB;EACE;IACE,WAAW;;;;EAIb;EACA,2BAA2B;EAC3B;IACE,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,eAAe;;EAEjB;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,eAAe;;EAEjB;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,eAAe;IACf,eAAe;EACjB;;EAEA;;;;KAIG;;;EAGH;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,eAAe;EACjB;EACA;;IAEE,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;EACf;;EAEA;;IAEE,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;;EAE3B;EACA;;IAEE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;;IAEb,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;IAEE,cAAc;;EAEhB;;;;EAIA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,mDAAmD;IACnD,yBAAyB;;EAE3B;;;EAGA;;IAEE,cAAc;;;EAGhB;;EAEA;IACE,kBAAkB;IAClB,UAAU;;EAEZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,eAAe;;EAEjB;;EAEA;IACE,kBAAkB;;EAEpB;;EAEA;;;IAGE,UAAU;;EAEZ;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;;;IAGE,eAAe;;IAEf,cAAc;;IAEd,mBAAmB;;EAErB;;;;;;;EAOA;;;;IAIE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;;IAEjB,qBAAqB;;IAErB,+BAA+B;;IAE/B,YAAY;;IAEZ,aAAa;;IAEb,kBAAkB;;IAElB,eAAe;;EAEjB;;;;;EAKA;;IAEE,WAAW;;IAEX,YAAY;;IAEZ,kBAAkB;;IAElB,yEAAyE,EAAE,0DAA0D;;IAErI,sBAAsB;;EAExB;;EAEA;;IAEE,eAAe;;EAEjB;EACA;IACE,eAAe;;IAEf,YAAY;IACZ,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,6BAA6B;IAC7B,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;EACpB;EACA,mCAAmC;;EAEnC;IACE,+DAA+D;IAC/D,iBAAiB;IACjB,2BAA2B;EAC7B;EACA;IACE,SAAS;EACX;EACA;IACE,kDAAkD;IAClD,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA,0BAA0B;;;EAG1B;;IAEE,SAAO;IACP,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;;IAElB,yBAAyB;;IAEzB,kBAAkB;;EAEpB;EACA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,yBAAyB;;EAE3B;EACA;MACI,aAAa;MACb,sBAAsB;MACtB,sBAAsB;MACtB,WAAW;MACX,yBAAyB;MACzB,yBAAyB;MACzB,kBAAkB;MAClB,uBAAuB;EAC3B;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,aAAa;IACb,8CAA8C;IAC9C,wCAAwC;IACxC,YAAY;IACZ,8BAA8B;IAC9B,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;AACpC;EACE;IACE,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,aAAa;;IAEb,mBAAmB;;EAErB;;EAEA;IACE,SAAS;EACX;;;EAGA;;IAEE,aAAa;;IAEb,kBAAkB;;IAElB,kBAAkB;;IAElB,gCAAgC;;IAEhC,eAAe;;EAEjB;EACA;IACE,YAAY;;EAEd;;;;EAIA;;;IAGE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;;EAEb;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;;IAEZ,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;;;IAGE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,YAAY;;EAEd;;EAEA;IACE,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,mBAAmB;EACrB;;;EAGA;;IAEE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,YAAY;;;EAGd;EACA;IACE,WAAW;;IAEX,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,SAAS;;;EAGX;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;;IAExB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,mBAAmB;GACpB,YAAY;GACZ,gBAAgB;GAChB,kCAAkC;IACjC,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,cAAc;;EAEhB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,6BAA6B;IAC7B,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,UAAU;;MAER,kBAAkB;MAClB,kBAAkB;;;;;IAKpB;EACF;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;;IAElB,YAAY;IACZ,WAAW;;IAEX,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;;EAE3B;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;;;EAGrB;;EAEA;;IAEE,gCAAgC;;IAEhC,eAAe;;IAEf,WAAW;;IAEX,kBAAkB;;IAElB,gBAAgB;;EAElB;;;;;;EAMA,WAAW;;;;EAIX;MACI,WAAW;EACf;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,uDAAuD;;IAEvD,mBAAmB;;IAEnB,yBAAyB;;IAEzB,yBAAyB;;EAE3B;EACA,oGAAoG","sourcesContent":[".main-sop {\r\n\r\n    background-color: #ffffff;\r\n    width:100%;\r\n    font-family: 'Graphik', sans-serif;\r\n    display:flex;\r\n    flex-direction:column;\r\n   \r\n  \r\n  }\r\n  .header-sop {\r\n    background-color: #fff;\r\n    justify-items: center;\r\n    align-items: center;\r\n    display: flex;\r\n    border: 1px solid #747BA9;\r\n    flex-direction: row;\r\n    height: 70px;\r\n  }\r\n  .logo-header-sop{\r\n  \r\n    width:25%;\r\n  }\r\n  .Heading-sop{\r\n    color: black;\r\n    text-align: left;\r\n    font-size: 20px;\r\n  }\r\n  .admin-img-sop{\r\n    width: 85%;\r\n  }\r\n  .admin-text-sop{\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n    font-size: 14px;\r\n    color: black;\r\n  }\r\n  \r\n  .collapse-img-sop{\r\n    justify-content: end;\r\n    padding-right: 10px;\r\n    align-items: center;\r\n    align-self: flex-end;\r\n   }\r\n  \r\n  \r\n  .Admin-sop{\r\n   display: flex;\r\n   flex-direction: row;\r\n   margin-left: 1100px;\r\n   justify-content: end;\r\n   padding-right: 10px;\r\n   align-items: center;\r\n   align-self: flex-end;\r\n  }\r\n  \r\n  \r\n  .second-container-sop {\r\n    \r\n  \r\n  \r\n    margin-top: 20px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    border-radius: 10px;\r\n    border: 1px solid #747BA9;\r\n    margin-left: 30px;\r\n    min-height: 540px;\r\n   \r\n    padding: 20px;\r\n    margin-right: 15px;\r\n    text-align: left;\r\n    background-color: white;\r\n  \r\n  }\r\n  .text-sop{\r\n    color:#000;\r\n    font-size: 12px;\r\n  }\r\n  top-containerss-sop{\r\n    display: flex;\r\n   \r\n    flex-direction: column;\r\n  }\r\n  .top-container-sop{\r\n    display: flex;\r\n    background-color: #202342;\r\n    flex-direction: row;\r\n    \r\n    min-height: 40px;\r\n    border: 1px solid #747BA9;\r\n  }\r\n  .left-section-sop{\r\n    display: flex;\r\n    width: 55%;\r\n    flex-direction: column;\r\n    background-color:   rgba(255, 255, 255, 0.05);\r\n  }\r\n  .select-dropdown-s{\r\n    color: #000;\r\n    display: flex;\r\n    flex-direction: row;\r\n    font-size: 10px;\r\n    padding-top: 20px;\r\n  }\r\n  .id::placeholder{\r\n    color: white;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    justify-content: center;\r\n  }\r\n  .data-display-sop{\r\n    color: black;\r\n  \r\n  }\r\n  \r\n  .button-sop{\r\n    color: #fff;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    width: 50%;\r\n    background-color: #6B5CD1;\r\n    border-radius: 5px;\r\n    border: 1px solid #747BA9;\r\n   \r\n   \r\n    \r\n    margin: 5px;\r\n    justify-content: center;\r\n   \r\n    height:30px;\r\n  }\r\n  /* Add styles for the custom Accordion */\r\n  .custom-accordion-sop {\r\n    background-color: #294170;\r\n    border: none; /* Remove default border */\r\n  }\r\n  \r\n  /* Style for each Accordion item */\r\n  \r\n  \r\n  /* Style for Accordion headers */\r\n  .custom-accordion-header-sop {\r\n   \r\n    color: white; /* Set text color for headers */\r\n    background-color: #fff;\r\n    font-size: 12px;\r\n    padding: 0px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  /* Style for Accordion bodies */\r\n  .custom-accordion-body-sop {\r\n   color: white;\r\n   font-size: 12px;\r\n    padding: 10px; /* Adjust padding as needed */\r\n  }\r\n  \r\n  .loading-sop {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 16px;\r\n    color: #000;\r\n    margin-top: 10px;\r\n  }\r\n  .multiSelectContainer-sop {\r\n    position: relative;\r\n    border-radius: 3px;\r\n    background-color: #FFFFFF;\r\n    text-align: left;\r\n    color:#A100FF;\r\n    font-size: 12px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .loading-sop::after{\r\n    content: \"\";\r\n    display: inline-block;\r\n    width: 16px;\r\n    height: 16px;\r\n    border-radius: 50%;\r\n    border: 1px solid #747BA9;\r\n    border-top-color: transparent;\r\n    animation: spin 0.8s linear infinite;\r\n  }\r\n  \r\n  @keyframes spin {\r\n    to-s {\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n  .assistant-heading-sop {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    margin-bottom: 10px;\r\n    margin-left: 5px;\r\n    color: white;\r\n    text-align: center;\r\n    \r\n  }\r\n  \r\n  \r\n  \r\n  \r\n  .middle-panel-sop {\r\n  \r\n    display: flex;\r\n  \r\n    width:45%;\r\n  \r\n    padding:20px;\r\n    padding-top:5px;\r\n    flex-direction: column;\r\n  \r\n    justify-content: start;\r\n  \r\n    align-items: center;\r\n  \r\n    background-color: #fff;\r\n  \r\n  }\r\n  \r\n  \r\n  \r\n  \r\n  .right-panel-sop {\r\n  \r\n    position: relative;\r\n    width:30%;\r\n    background-color: #fff;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-end;\r\n    background: linear-gradient(0deg, #002644, #002644),\r\n    linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2));\r\n    border: 1px solid #747BA9;\r\n  \r\n  }\r\n  \r\n  \r\n  \r\n  \r\n  .title-sop {\r\n  \r\n    font-family: 'Arial', sans-serif;\r\n  \r\n    font-size: 28px;\r\n  \r\n    color: #333;\r\n  \r\n    margin-bottom: 20px;\r\n  \r\n  }\r\n  \r\n  \r\n  \r\n  \r\n  .dropdown-container-sop {\r\n  \r\n    margin-bottom: 20px;\r\n  \r\n  }\r\n  \r\n  \r\n  .dropdown-label-sop {\r\n  \r\n    color:black;\r\n    font-size:12px;\r\n    margin-top: 10px;\r\n    margin-right: 50px;\r\n  }\r\n  .custom-multiselect .multiselect__placeholder::before {\r\n    content: 'Select Category'; /* Set the placeholder text */\r\n    color: #ffffff; /* Set the text color to white */\r\n    /* Add any other custom styles for the placeholder */\r\n  }\r\n  \r\n  .logo-class-sop{\r\n    \r\n    width: 70%;\r\n    margin-left: 20px;\r\n  }\r\n  .selected-files-container-sop {\r\n    margin-top: 10px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    min-height: 50px;\r\n  }\r\n  .pdf-icon-sop{\r\n    padding: 10px;\r\n  \r\n  }\r\n  .browse-sop{\r\n    align-content: center;\r\n    color: #fff;\r\n    font-size: 13px;\r\n    margin-left:80px;\r\n   margin-top:14px;\r\n   padding:5px;\r\n   border:1px solid  #747BA9;\r\n   margin-right:5px;\r\n   height:30px;\r\n   border-radius:3px;\r\n    font-weight:500;\r\n  }\r\n  .top-suma1-sop{\r\n    width: 2.5%;\r\n   \r\n    margin-right: 5px;\r\n   \r\n  \r\n  }\r\n  .chatboticon {\r\n    float: right;\r\n}\r\n  .top-suma-sop{\r\n    width: 2.5%;\r\n    \r\n   \r\n   \r\n  }\r\n  /* CSS for selected files */\r\n  .selected-file-sop {\r\n    background-color: rgba(255, 255, 255, 0.05);\r\n    display: flex;\r\n    flex-direction: row;\r\n    width: 60%;\r\n    min-height: 40px;\r\n    margin-left: 30px;\r\n    margin-top: 20px;\r\n    text-align: center;\r\n    border-radius: 4px;\r\n    color: #fff;\r\n    font-size: 10px;\r\n  }\r\n \r\n  .dropdown-select-s {\r\n  \r\n    background: #FFFFFF;\r\n    appearance: none;\r\n    border: 2px dashed;\r\n    height: 30px;\r\n    border-radius: 3px;\r\n    border: 1px;\r\n    color:#A100FF;\r\n    font-size: 12px;\r\n  \r\n  }\r\n  \r\n  .option-class-s{\r\n    background-color:#FFFFFF;\r\n  }\r\n  .option-class-s:checked{\r\n    background-color: #fff;\r\n  }\r\n  .category-container-s{\r\n    width: 50%;\r\n    background: #FFFFFF;\r\n    border: 2px dashed;\r\n    box-shadow: 0px 0px 0px 2px grey;\r\n    height: 30px;\r\n    border-radius: 3px;\r\n    border: 1px;\r\n    color:#8392B6;\r\n    font-size: 12px;\r\n  \r\n  }\r\n  \r\n  .drag-sop{\r\n    align-content: center;\r\n    color:#FFFFFF;\r\n    font-size: 12px;\r\n    font-weight:500;\r\n  }\r\n  \r\n  /* .drag-logo{\r\n  \r\n    \r\n  \r\n  } */\r\n  \r\n\r\n  .accordion-button {\r\n    width: 100%;\r\n    background-color: white;\r\n    max-height: 40px;\r\n    color: black;\r\n  }\r\n  .accordion-button:not(.collapsed){\r\n    background-color:#3C4069 ;\r\n    color: #fff;\r\n  }\r\n  .accordion-button.collapsed{\r\n    background-color:#747BA9 ;\r\n    color: #fff;\r\n  }\r\n \r\n  .header-class-sop{\r\n    background-color: white;\r\n  }\r\n  \r\n  .file-class-sop{\r\n    visibility:hidden;\r\n  }\r\n  \r\n  .or-class-sop{\r\n    color:#FFFFFF4D;\r\n    font-size: 12px;\r\n    font-weight:500;\r\n  }\r\n  .Assist-header-sop{\r\n   \r\n    align-self: flex-start;\r\n    margin-left: 35px;\r\n    color:#A100FF;\r\n  }\r\n  \r\n  .upload-container-sop {\r\n  \r\n    margin-bottom: 10px;\r\n    margin-top: 30px;\r\n    text-align: center;\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content:center;\r\n    height: 130px;\r\n    border-radius: 15px;\r\n    background: #294170;\r\n    border: 1px solid #747BA9;\r\n  \r\n  }\r\n  .drag-container-sop{\r\n   \r\n    background-color: #3E5FA2;\r\n    border-radius: 5px;\r\n    height: 30px;\r\n    align-items: center;\r\n    display: flex;\r\n    align-self: center;\r\n    width: 40%;\r\n    flex-direction: row;\r\n  }\r\n  .drag-logo-sop{\r\n    width: 90%;\r\n  }\r\n  .collapse-class{\r\n    width:3%;\r\n  }\r\n  \r\n  .placeholder{\r\n    background-color: #fff;\r\n    color:#FFFFFF;\r\n    font-size: 10px;\r\n  }\r\n  .browse-container-sop{\r\n    background-color: #6B5CD1;\r\n    border-radius: 5px;\r\n    border: 1px solid #747BA9;\r\n    margin: 5px;\r\n    padding-left: 50px;\r\n    height: 30px;\r\n    display: flex;\r\n   \r\n    align-items: center;\r\n    width: 40%;\r\n    font-size: 10px;\r\n    flex-direction: row;\r\n  }\r\n  \r\n  .image-sop{\r\n    display: flex;\r\n    margin-top: 25px;\r\n    margin-left: 20px;\r\n    flex-direction: row;\r\n  }\r\n  .energy-header-sop{\r\n    font-size: 35px;\r\n    text-align: center;\r\n    font-weight: 8px;\r\n    color: #ffffff;\r\n  }\r\n  \r\n  .upload-container-sop label{\r\n  \r\n    display: block;\r\n  \r\n  }\r\n  \r\n  \r\n  \r\n  .corrosion-result-sop{\r\n    margin-bottom: 10px;\r\n    text-align: center;\r\n    padding: 10px;\r\n    justify-content:center;\r\n    font-size:15px;\r\n    font-weight:500;\r\n    color:#FFFFFF;\r\n    min-height: 20px;\r\n    border-radius: 24px;\r\n    background: linear-gradient(0deg, #122B45, #122B45);\r\n    border: 1px solid #747BA9;\r\n  \r\n  }\r\n  \r\n  \r\n  .upload-container-sop input[type='file'] {\r\n  \r\n    display: block;\r\n    \r\n  \r\n  }\r\n  \r\n  .multipleSelection-sop {\r\n    padding-left: 30px;\r\n    width: 80%;\r\n    \r\n  }\r\n  \r\n  .selectBox-sop {\r\n    position: relative;\r\n  }\r\n  \r\n  .selectBox-sop select {\r\n    width: 100%;\r\n    background: #FFFFFF;\r\n    border: 2px dashed;\r\n    box-shadow: 0px 0px 0px 2px grey;\r\n    height: 30px;\r\n    padding: 5px;\r\n    border-radius: 3px;\r\n    border: 1px;\r\n    color:#8392B6;\r\n    font-size: 12px;\r\n    \r\n  }\r\n  \r\n  .overSelect-s {\r\n    position: absolute;\r\n    \r\n  }\r\n  \r\n  .micimg-sop{\r\n    \r\n   \r\n    width: 70%;\r\n  \r\n  }\r\n  \r\n  #checkBoxes-s {\r\n    /* display: none; */\r\n    border: 1px #8DF5E4 solid;\r\n  }\r\n  \r\n  #checkBoxes label-s {\r\n    display: block;\r\n  }\r\n  \r\n  #checkBoxes label:hover-s {\r\n    background-color: #4F615E;\r\n  }\r\n  \r\n  \r\n  .corrosion-detection-s {\r\n  \r\n  \r\n    font-size: 24px;\r\n  \r\n    color: #FFFFFF;\r\n  \r\n    margin-bottom: 10px;\r\n  \r\n  }\r\n  \r\n  \r\n\r\n \r\n  \r\n  \r\n  .chat-popup-sop {\r\n  \r\n    \r\n  \r\n    display: flex;\r\n    flex-direction: column;\r\n    text-align: right;\r\n  \r\n    align-items: flex-end;\r\n  \r\n    /* background-color: #007bff; */\r\n  \r\n    color: white;\r\n  \r\n    padding: 10px;\r\n  \r\n    border-radius: 5px;\r\n  \r\n    cursor: pointer;\r\n  \r\n  }\r\n  \r\n  \r\n  \r\n  \r\n  .robot-icon-sop {\r\n  \r\n    width: 20px;\r\n  \r\n    height: 20px;\r\n  \r\n    margin-right: 10px;\r\n  \r\n    background-image: url('https://www.ibef.org/assets/images/Oil-Gas-2.jpg'); /* Replace with the path to your custom robot icon image */\r\n  \r\n    background-size: cover;\r\n  \r\n  }\r\n  \r\n  .chat-popup-text-sop {\r\n  \r\n    font-size: 14px;\r\n  \r\n  }\r\n  .summary-sop{\r\n    font-size: 17px;\r\n    \r\n    margin: 30px;\r\n    color: #000;\r\n  }\r\n  .summary-header-sop{\r\n    font-size: 20px;\r\n    margin-top: 30px;\r\n    margin-left: 40px;\r\n    font-weight: 20px;\r\n    color:#fff;\r\n  }\r\n  .icon-sop{\r\n    margin-right: 50px;\r\n  }\r\n  .icon-row-sop{\r\n    display: flex;\r\n    flex-direction: row;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    border-top: 1px solid #747BA9;\r\n    border-bottom: 1px solid #747BA9;\r\n    margin-top: 40px;\r\n    padding-left: 40px;\r\n  }\r\n  /* Add your other CSS styles here */\r\n  \r\n  .header-starts-with-hyphen {\r\n    /* Apply your custom styling for headers starting with hyphen */\r\n    /* For example: */\r\n    background-color: lightgray;\r\n  }\r\n  .internalItemClasses{\r\n    color:red;\r\n  }\r\n  .header-is-numeric {\r\n    /* Apply your custom styling for numeric headers */\r\n    /* For example: */\r\n    background-color: lightblue;\r\n  }\r\n  \r\n  /* ... (Other CSS rules) */\r\n  \r\n  \r\n  .chatbot-container-sop {\r\n  \r\n    flex: 1;\r\n    /* padding: 10px; */\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: #1E203D;\r\n    width: 100%;\r\n    align-self: center;\r\n   \r\n    border: 1px solid #747BA9;\r\n  \r\n    border-radius: 3px;\r\n  \r\n  }\r\n  .top-chat-container-sop{\r\n    margin-top: 5px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    border-radius: 5px;\r\n    border-color: #8392B6;\r\n    height: 60px;\r\n    border: 3px; \r\n    text-align: left;\r\n    background-color: #4B70B4;\r\n  \r\n  }\r\n  .right-section-sop{\r\n      display: flex;\r\n      flex-direction: column;\r\n      background-color: #fff;\r\n      width:720px;\r\n      background-color: #252843;\r\n      border: 1px solid #747BA9;\r\n      border-radius: 3px;\r\n      align-content: flex-end;\r\n  }\r\n  .popup-message-sop{\r\n    background-color: #8392B6;\r\n    color: #ffffff;\r\n  }\r\n  .message-footer-apm {\r\n    display: flex;\r\n    /* background-color: rgba(116, 123, 169, 1); */\r\n    border: 1px solid rgba(116, 123, 169, 1);\r\n    height: 34px;\r\n    justify-content: space-between;\r\n    padding: 5px 10px 5px 10px;\r\n    margin-left: -10px;\r\n    margin-right: -10px;\r\n    margin-bottom: -10px;\r\n    margin-top: 20px;\r\n    border-radius: 0px 0px 10px 10px;\r\n}\r\n  .message-text-chart-apm{\r\n    padding: 10px 10px 10px 10px;\r\n    font-size: 12px;\r\n    color: white;\r\n    border-radius: 5px;\r\n    max-width: 1000px;\r\n    width: fit-content;\r\n    margin-left: 30px;\r\n  }\r\n  \r\n  .chat-messages-sop {\r\n    overflow-y:  scroll;\r\n    height: 430px;\r\n   \r\n    margin-bottom: 10px;\r\n  \r\n  }\r\n  \r\n  .chat-icon-sop{\r\n    width:20%;\r\n  }\r\n  \r\n  \r\n  .chat-message-sop {\r\n  \r\n    padding: 10px;\r\n  \r\n    margin-bottom: 5px;\r\n    \r\n    border-radius: 5px;\r\n  \r\n    font-family: 'Arial', sans-serif;\r\n  \r\n    font-size: 14px;\r\n  \r\n  }\r\n  .searchWrapper {\r\n    padding: 2px;\r\n  \r\n  }\r\n  \r\n  \r\n  \r\n  .user-sop {\r\n  \r\n    \r\n    display: flex;\r\n    flex-direction: row;\r\n    text-align:start;\r\n    margin: 10px;\r\n    padding: 10px;\r\n    background-color: #F5FBFF;\r\n    border: 1px solid #747BA9;\r\n    border-radius: 5px;\r\n    min-height: 35px;\r\n    color:black;\r\n  \r\n  }\r\n  .dropdowns{\r\n    display: flex;\r\n    flex-direction: row;\r\n  }\r\n  \r\n  .accordion-header {\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n  }\r\n  .Category-select-sop{\r\n    background-color: #4286F5;\r\n    border-radius: 5px;\r\n    border: 1px solid #747BA9;\r\n    margin: 10px;\r\n    color: white;\r\n   \r\n    height: 30px;\r\n    display: flex;\r\n    min-height: 50px;\r\n    align-items: center;\r\n    width: 100%;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    flex-direction: row;\r\n  }\r\n  \r\n  .message-icon-sop{\r\n    padding-right: 10px;\r\n    padding-bottom: 5px;\r\n  }\r\n  \r\n  .bot-sop {\r\n  \r\n   \r\n    display: flex;\r\n    flex-direction: row;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    background-color: #CBDEFF;\r\n    border: 1px solid #8799C5;\r\n    color: black;\r\n    min-height: 35px;\r\n    margin: 10px;\r\n  \r\n  }\r\n  \r\n  .container-sop{\r\n    height: 550px;\r\n    display: flex;\r\n    background-color: #202342;\r\n    flex-direction: row;\r\n  }\r\n  \r\n  \r\n  .chat-input-container-sop {\r\n  \r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    color:#000;\r\n    padding: 5px;\r\n   \r\n    \r\n  }\r\n  .Title-sop{\r\n    color: #000;\r\n    \r\n    font-size: 30px;\r\n    margin-left: 400px;\r\n  }\r\n  \r\n  .send-sop{\r\n    \r\n    width: 5%;\r\n    \r\n    \r\n  }\r\n\r\n  .Assistant-sop{\r\n    font-size: 18px;\r\n    font-weight: 400;\r\n    display: flex;\r\n    flex-direction: row;\r\n    background-color:#252843;\r\n   \r\n    padding-top: 5px;\r\n    text-align: center;\r\n    height: 35px;\r\n    margin-bottom: 5px;\r\n    color: #000;\r\n  }\r\n  .assis-sop{\r\n    padding-left: 200px;\r\n   color: white;\r\n   font-weight: 500;\r\n   font-family: 'Graphik', sans-serif;\r\n    background-color:#252843;\r\n  }\r\n  .icon-o{\r\n    margin-right: 50px;\r\n    height: 30px;\r\n    color: #6C3287;\r\n   \r\n  }\r\n  .icon-row-o{\r\n    display: flex;\r\n    flex-direction: row;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    border-top: 1px solid #8392B6;\r\n    border-bottom: 1px solid #8392B6;\r\n    margin-top: 40px;\r\n    padding-left: 40px;\r\n  }\r\n  .fetch-questions-button-sop{\r\n    color:#fff;\r\n     \r\n      margin-bottom: 5px;\r\n      margin-left: 130px;\r\n     \r\n     \r\n     \r\n      \r\n    }\r\n  .iconi-sop{\r\n    width: 50%;\r\n    margin-bottom: 5px;\r\n  }\r\n  \r\n  .chat-input-sop {\r\n  \r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n  \r\n    padding: 5px;\r\n    width: 100%;\r\n   \r\n    color: #fff;\r\n    font-size: 14px;\r\n    height: 50px;\r\n    border-radius:10px;\r\n    background-color:#1A1C35;\r\n    border: 1px solid #747BA9;\r\n  \r\n  }\r\n  \r\n  .chat-input-sop:focus{\r\n    border: 1px solid #747BA9;\r\n  }\r\n  .check-image-s{\r\n    border-radius: 10px;\r\n  \r\n  \r\n  }\r\n  \r\n  .footer-s {\r\n  \r\n    font-family: 'Arial', sans-serif;\r\n  \r\n    font-size: 14px;\r\n  \r\n    color: #666;\r\n  \r\n    text-align: center;\r\n  \r\n    margin-top: auto;\r\n  \r\n  }\r\n  \r\n  \r\n \r\n  \r\n \r\n  /* Handle */\r\n  \r\n \r\n  \r\n  .icon_down_dir:before {\r\n      content: \"\";\r\n  }\r\n  \r\n  .accordion-body{\r\n    background-color: #1E203D;\r\n    color: white;\r\n    overflow-y: scroll;\r\n    max-height: 360px;\r\n  }\r\n  .accordion-item {\r\n    background-color: #1E203D;\r\n  }\r\n  .autocomplete-container .suggestions-container ul li a{\r\n  \r\n    font: normal normal normal 14px/25px Graphik !important;\r\n  \r\n    letter-spacing: 0px;\r\n  \r\n    color: #5C5C5C !important;\r\n  \r\n    padding: 0 5px !important;\r\n  \r\n  }\r\n  /* .multiSelectContainer .icon_down_dir::before-s { content: url(\"./images/dropdown_arrow.svg\"); } */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
